<template>
 <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
                 <v-toolbar
          color="blue lighten-3"
          dark
        >

          <v-toolbar-title   class="headline">Ladda upp protokoll</v-toolbar-title>
        </v-toolbar>
            <v-card-text>
              <v-container>
                <v-flex>
                  <v-flex>
                    <v-text-field
                      label="Titel"
                      hint="titel på protokollet."
                      required
                      v-model="NewAP.name"
                    ></v-text-field>
                  </v-flex>    
                <v-flex>
                    <v-text-field
                      label="Beskrivning"
                      hint="En kort beskrivning som förklarar vad protokollet rör."
                      required
                      v-model="NewAP.description"
                    ></v-text-field>
                  </v-flex>    
                  <v-flex>
                    <v-text-field
                      label="Länk"
                      hint="Länk till protokollet"
                      required
                      v-model="NewAP.link"
                    ></v-text-field>
                  </v-flex>  
                  <v-flex>


       </v-flex> 
 <v-flex>
                    <v-select
                      v-model="NewAP.reviewer"
                      :items="membernameandId"
                      item-text="[0]"
                      item-value="[1]"
                      attach
                      chips
                      label="Justerare"
                      hint="Vem har justerat dokumentet."
                    ></v-select>
                  </v-flex>

                                     <v-flex justify="center">
                        <h3>När är dokumentet är skapat</h3>
    <v-date-picker 
          color="blue lighten-3" v-model="NewAP.createDate"></v-date-picker>
    
                   </v-flex>
                                              
                   
                  <v-flex>
    <v-radio-group label="Är länken tidsbestämd? För ökad säkerhet rekommenderas alltid tidsbestämda länkar samt att endast de inom organisationen ska ha åtkomst."
     v-model="Specialaccess"
    >
      <v-radio
        label="Ja"
        value="ja"
      ></v-radio>
      <v-radio
        label="Nej"
        value="nej"
      ></v-radio>
    </v-radio-group>
       </v-flex> 
    <v-flex v-if="Specialaccess=='ja'">
                        <p>När går den tidsbestämda länken ut?</p>
    <v-date-picker v-model="NewAP.expireDate"></v-date-picker>
                   </v-flex>
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark color="red darken-1" @click="show = false">
                Stäng
              </v-btn>
              <v-btn
                color="green lighten-1"
                text
                dark
                @click="change()"
                v-if="Oldclass!=null"
              >
                Uppdatera protokoll
              </v-btn>
                            <v-btn
                color="green lighten-1"
                text
                dark
                @click="change()"
                v-else
              >
                Skapa protokoll
              </v-btn>
            </v-card-actions>
          </v-card>
 </v-dialog>
</template>
<script>
import { mapActions,mapGetters } from "vuex";
export default {
    name:"NewAP",

  computed: {
    show: {
      get () {
          if (this.Oldclass!=null) {
        this.NewAP=this.Oldclass;
          this.update=true;
          }
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },

    created(){
      if (this.Oldclass!=null) {
        this.NewAP=this.Oldclass;
      }
    },
    props:{
        membernameandId: Array,
        Oldclass: Object,
        schoolId: String,
        id:String,
        value: Boolean
    },
data() {
    return {
         update:false ,
        Specialaccess: "nej",
            NewAP: {
        schoolId: this.schoolId,
      },
      locfun: null,
    };
  },

  methods: {
    ...mapActions("classesAP", ["createAP","saveAP"]),
    ...mapActions(['showSuccessSnackbar']),
  change(){
    if ( typeof(this.NewAP.createDate)=="object") {
    this.NewAP.createDate=this.NewAP.createDate.getTime();
    }
    if (this.NewAP.hasOwnProperty('expireDate')) 
    if ( typeof(this.NewAP.expireDate)=="object") {
    this.NewAP.expireDate=this.NewAP.expireDate.getTime();
    }
    // if (this.NewAP.accessType.length!=1) {
    //   if (this.NewAP.accessType.length==3) {
    //     this.NewAP.accessType=="all";
    //   }
    //   else if
    // }

    if (this.update==false) {
      this.NewAP.type="Protokoll";
      this.NewAP.uploader= this.id;
      this.NewAP.schoolId= this.schoolId;

    this.createAP(this.NewAP);
    this.showSuccessSnackbar('Protokoll ' + this.NewAP.name+ ' är skapad!');
    }
    else
    {
    this.saveAP(this.NewAP);
    this.showSuccessSnackbar('Protokoll för ' +  this.NewAP.name+ ' är updaterad!');
    } 
     if (this.Oldclass==null) {
       this.NewAP= {
      }
     }
     
     this.show = false;
  }
    
  }
}
</script>
<style >

</style>